if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        const productUrl = opener.getAttribute("data-product-url");
        if (!productUrl) {
          console.error(
            "Error: El botón no tiene el atributo data-product-url"
          );
          return;
        }

        fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );

            // PROTECCIÓN: Si no existe el elemento, no seguimos
            if (!this.productElement) return;

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton)
              Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);

            this.initQuickAddGift();
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      preventDuplicatedIDs() {
        // PROTECCIÓN: Verificar que productElement existe antes de leer dataset
        if (!this.productElement || !this.productElement.dataset) return;

        const sectionId = this.productElement.dataset.section;
        if (!sectionId) return;

        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios, product-info")
          .forEach((el) => (el.dataset.originalSection = sectionId));
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll("script").forEach((oldScript) => {
          const newScript = document.createElement("script");
          Array.from(oldScript.attributes).forEach((attr) =>
            newScript.setAttribute(attr.name, attr.value)
          );
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }

      initQuickAddGift() {
        const modal = this.modalContent;
        const giftCheckbox = modal.querySelector("#gift-checkbox");
        const nativeForm = modal.querySelector("product-form form");
        const nativeSubmitBtn = modal.querySelector('[name="add"]');

        if (!nativeSubmitBtn || !nativeForm) return;

        // 1. Clonamos el botón para matar los listeners de Shopify/Dawn
        // Esto nos da un botón "limpio" que no enviará el formulario automáticamente
        const customBtn = nativeSubmitBtn.cloneNode(true);
        customBtn.type = "button"; // Evitamos que sea 'submit'
        customBtn.classList.add("custom-added-btn");
        nativeSubmitBtn.parentNode.replaceChild(customBtn, nativeSubmitBtn);

        customBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
      
          customBtn.setAttribute('aria-disabled', 'true');
          customBtn.classList.add('loading');
          const spinner = customBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
      
          try {
            const variantId = modal.querySelector('input[name="id"]').value;
            const isGiftChecked = giftCheckbox && giftCheckbox.checked;
            const giftVariantId = isGiftChecked ? giftCheckbox.value : null;
            
            let properties = {};
            let bundleId = null;
      
            // --- LÓGICA DE RECICLAJE DE ID ---
            // Consultamos el carrito actual antes de agregar
            const cartStatus = await fetch('/cart.js').then(r => r.json());
            
            // Buscamos si ya existe esta variante con un BundleId
            const existingItem = cartStatus.items.find(item => 
              item.variant_id == variantId && 
              item.properties && 
              item.properties._BundleId
            );
      
            if (existingItem) {
              // Si ya existe, usamos su ID para que Shopify sume la cantidad en la misma línea
              bundleId = existingItem.properties._BundleId;
              properties['_BundleId'] = bundleId;
            } else if (isGiftChecked) {
              // Si no existe pero el usuario quiere bolsa, creamos uno nuevo
              bundleId = 'bundle_' + Date.now();
              properties['_BundleId'] = bundleId;
            }
            // ---------------------------------
      
            // 1. AGREGAR PRODUCTO PRINCIPAL
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: variantId,
                  quantity: 1,
                  properties: properties
                }]
              })
            });
      
            if (!response.ok) throw new Error('Error al agregar');
      
            // 2. AGREGAR BOLSA (Solo si el checkbox está marcado)
            // Nota: Si el ID fue reciclado, window.addGiftToCart sumará +1 a la bolsa existente 
            // porque recibirá el mismo ID y variante.
            if (isGiftChecked && bundleId) {
              await window.addGiftToCart(giftVariantId, bundleId);
            }
      
            // 3. FINALIZAR
            if (window.forceBagCorrection) await window.forceBagCorrection();
            await refreshCartDrawer(); // Esta función ya tiene el fix de las clases arriba
      
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
              else cartDrawer.classList.add('active');
            }
            
            this.hide();
      
          } catch (error) {
            console.error('[GiftDebug] Error:', error);
          } finally {
            customBtn.removeAttribute('aria-disabled');
            customBtn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          }
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          "variant-radios,variant-selects"
        );
        if (!variantPicker) return;
        variantPicker.setAttribute("data-update-url", "false");
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        this.productElement
          .querySelectorAll("modal-dialog")
          .forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios, product-info")
          .forEach((el) => (el.dataset.originalSection = sectionId));
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;
        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        if (!product.classList.contains("product--columns")) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let sizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
        if (product.classList.contains("product--medium"))
          sizes = sizes.replace("715px", "605px");
        else if (product.classList.contains("product--small"))
          sizes = sizes.replace("715px", "495px");

        mediaImages.forEach((img) => img.setAttribute("sizes", sizes));
      }
    }
  );
}
